<div class="flex-fill center-center splash-wrapper">
  <img class="loader fadeInfadeOut" src="assets/splash_loader.svg" />
</div>
